import { Link } from 'react-router-dom'
import { ArrowTopRightOnSquareIcon, PlusIcon, UserCircleIcon } from '@heroicons/react/24/outline'

const getPersonId = osoba => osoba?._id || osoba?.id

const getPlacowkaId = placowka => placowka?._id || placowka?.id || null

export default function PlacowkaPeopleCard({ people = [], placowka = null, onAdd = null }) {
	const rows = Array.isArray(people) ? people : []
	const placowkaId = getPlacowkaId(placowka)

	return (
		<li className="col-span-1">
			<div className="flex h-[440px] w-full flex-col overflow-hidden rounded-md border border-slate-200 bg-gradient-to-b from-slate-50 to-white shadow-sm">
				<div className="flex flex-shrink-0 flex-row gap-3 border-b border-slate-300 bg-gray-100 px-6 py-3 sm:items-center sm:justify-between">
					<div className="flex items-start gap-3">
						<div className="flex flex-col gap-1">
							<h3 className="flex items-center gap-2 text-lg font-semibold text-slate-900">
								<UserCircleIcon className="h-5 w-5 text-sky-700" />
								<span>Osoby</span>
							</h3>
						</div>
					</div>
					<div className="ml-auto flex flex-wrap items-center gap-3">
						{placowkaId && onAdd ? (
							<button
								type="button"
								onClick={() => onAdd(placowka)}
								className="inline-flex items-center gap-1.5 rounded-md bg-sky-700 px-3 py-1.5 text-sm font-medium text-white hover:bg-sky-800"
							>
								<PlusIcon className="h-4 w-4" />
								<span>Dodaj</span>
							</button>
						) : null}
						<Link
							to={placowkaId ? `/klienci/osoba?id_placowka=${encodeURIComponent(placowkaId)}` : '/klienci/osoba'}
							className="inline-flex items-center gap-2 text-sm text-sky-700 hover:text-sky-800"
						>
							<ArrowTopRightOnSquareIcon className="h-5 w-5" />
							<span>Przejdz do listy</span>
						</Link>
					</div>
				</div>

				<div className="flex min-h-0 flex-1 flex-col overflow-hidden px-4 pb-4 sm:px-6 sm:pb-6">
					{rows.length === 0 ? (
						<div className="flex flex-1 items-center justify-center gap-3 rounded-md bg-white px-4 text-sm text-slate-600">
							<UserCircleIcon className="h-5 w-5 text-slate-400" />
							<span>Brak przypisanych osob.</span>
						</div>
					) : (
						<div className="flex min-h-0 flex-1 flex-col overflow-hidden rounded-md border border-slate-200 bg-white shadow-sm mt-4">
							<div className="min-h-0 flex-1 overflow-auto">
								<table className="min-w-full text-sm text-slate-800">
									<thead className="bg-slate-50 text-xs font-semibold uppercase tracking-wide text-slate-600">
										<tr>
											<th className="px-4 py-3 text-left">Dane</th>
											<th className="px-4 py-3 text-left">Funkcja</th>
											<th className="px-4 py-3 text-left">Email</th>
											<th className="px-4 py-3 text-left">Telefon</th>
										</tr>
									</thead>
									<tbody className="divide-y divide-slate-100">
										{rows.map((person, index) => {
											const rowKey = getPersonId(person) || index
											const personId = getPersonId(person)
											const dane =
												person?.imie_i_nazwisko || person?.imieNazwisko || person?.name || '-'
											return (
												<tr key={rowKey} className="bg-white transition-colors hover:bg-slate-50/80">
													<td className="whitespace-nowrap px-4 py-3 text-sm font-semibold text-slate-900">
														{personId ? (
															<Link
																to={`/klienci/osoba/details/${personId}`}
																className="text-sky-700 hover:text-sky-800 hover:underline">
																{dane}
															</Link>
														) : (
															dane
														)}
													</td>
													<td className="whitespace-nowrap px-4 py-3 text-sm text-slate-800">{person?.funkcja || '-'}</td>
													<td className="whitespace-nowrap px-4 py-3 text-sm text-slate-800">{person?.email || '-'}</td>
													<td className="whitespace-nowrap px-4 py-3 text-sm text-slate-800">{person?.telefon || person?.tel || '-'}</td>
												</tr>
											)
										})}
									</tbody>
								</table>
							</div>
						</div>
					)}
				</div>
			</div>
		</li>
	)
}
